import { render, staticRenderFns } from "./ListTermAccepted.vue?vue&type=template&id=0cc182ee&"
import script from "./ListTermAccepted.vue?vue&type=script&lang=js&"
export * from "./ListTermAccepted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports